export const getLoginUrl = (locale: string) => `/dashboard/${locale}/login`

export const getContactUrl = (contactId: string) =>
  `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${
    process.env.NEXT_PUBLIC_SIO_HOSTNAME
  }/dashboard/contacts/${contactId}`
